import { AnchorButton, AnchorButtonProps } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as Sentry from '@sentry/browser'
import * as React from 'react'
import { useSelector } from 'react-redux'
import PrinterV2 from '../printing/printer'
import { blurActiveInput } from '../routes/orders/packing/utils'
import PrinterToaster from '../printing/toaster'
import { AppState } from '../store'
import config from '../config'

interface Props {
  productId?: number
  productSkuLength?: number
  buttonText?: string
  onClickCallback?: () => void
}

const PrintBarcodeButton: React.FC<Props & AnchorButtonProps> = ({
  productId,
  productSkuLength,
  buttonText = 'Print Barcode',
  onClickCallback,
  ...buttonProps
}) => {
  const [loading, setLoading] = React.useState(false)

  const isEmployee = useSelector((s: AppState) => s.current.user.employee)

  const printBarcode = async event => {
    if (productSkuLength && productSkuLength > 27) {
      // anything over 27 chars won't be scannable
      PrinterToaster.show({
        intent: 'danger',
        message: 'Product SKU is too long. Shorten to 27 characters or less to print'
      })
      return
    }

    setLoading(true)

    const newTabPdfPrinter = (isEmployee || config.NEW_TAB_PDF_PRINTER()) && (event.ctrlKey || event.metaKey)
    const printer = new PrinterV2(newTabPdfPrinter)
    try {
      if (printer.listerConnectEnabled) {
        await printer.printProductLabelFromId([productId])
      }

      if (onClickCallback) {
        onClickCallback()
      }
    } catch (error) {
      PrinterToaster.show({ intent: 'danger', message: 'Unable to print barcode' })
      Sentry.captureException(error)
    } finally {
      setLoading(false)
    }
    blurActiveInput() // Release focus back to the body to allow for scanning on packing screen
  }

  return (
    <AnchorButton
      loading={loading}
      title="Print Barcode"
      text={buttonText}
      intent="primary"
      onClick={printBarcode}
      icon={IconNames.PRINT}
      small
      minimal
      {...(buttonProps as any)}
    />
  )
}

export default PrintBarcodeButton
